export default {
  namespaced: true,
  state: {
    globalFilter: {
      fromWave: 0, toWave: 0, rolling: 1, filterConfig: { filters: [] },
    },
    periodList: null,
    hotalertCount: 0,
    approvalCount: 0,
    appealCount: 0,
  },
  getters: {},
  mutations: {
    UPDATE_GLOBAL_FILTER(state, val) {
      state.globalFilter = val
    },
    UPDATE_PERIODS(state, val) {
      state.periodList = val
    },
    UPDATE_HOTALERT_COUNT(state, val) {
      state.hotalertCount = val
    },
    UPDATE_APPROVAL_COUNT(state, val) {
      state.approvalCount = val
    },
    UPDATE_APPEAL_COUNT(state, val) {
      state.appealCount = val
    },
  },
  actions: {},
}
